<template>
    <b-link v-bind="$attrs" v-on="$listeners" :to="{ name: 'Login' }" class="link-go-to-login">
        {{ $t('text') }}
    </b-link>
</template>

<script>
export default {
    name: 'LinkGoToLogin',
    i18n: {
        messages: {
            'en-US': {
                text: 'Back to login',
            },
            'es-ES': {
                text: 'Volver al inicio de sesión',
            },
            'pt-BR': {
                text: 'Voltar para login',
            },
        },
    },
}
</script>

<style lang="scss" scoped>
a.link-go-to-login {
    font-size: 1.15em;
    color: #6e6e6e;
}
</style>
